export default __webpack_public_path__ + "static/media/logo.150f04e2.png";